'use client'

import { createContext, ReactNode, useContext, useEffect, useState } from 'react'

import { Loading } from '@/common/components/Loading'
import { getRuntimeConfig, IRuntimeConfig, setRuntimeConfig } from '@/core/config/runtimeConfig'

interface IConfigRuntimeProviderProps {
  children: ReactNode
}

const RuntimeConfigContext = createContext<IRuntimeConfig>(getRuntimeConfig())

const ConfigRuntimeProvider: React.FC<IConfigRuntimeProviderProps> = ({ children }) => {
  const [config, setConfig] = useState<IRuntimeConfig | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadConfig = async (): Promise<void> => {
      try {
        const response = await fetch('/api/config', { cache: 'no-store' })

        if (!response.ok) {
          throw new Error(`Config fetch failed: ${response.status}`)
        }
        const data: IRuntimeConfig = await response.json()

        setRuntimeConfig(data)
        setConfig(data)
      } catch (ex) {
        console.error('No se pudo cargar la configuración runtime', ex)
        setError('No se pudo cargar la configuración de la aplicación')
      }
    }

    loadConfig()
  }, [])

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h3>Error de configuración</h3>
        <p>{error}</p>
        <p>Por favor, recargue la página o contacte al administrador.</p>
      </div>
    )
  }

  if (!config) {
    return <Loading />
  }

  return <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>
}

export const useRuntimeConfig = (): IRuntimeConfig => {
  return useContext(RuntimeConfigContext)
}

export default ConfigRuntimeProvider
